import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { validateFormPropertyOwners } from "../utils/validation/validate-property-owners";
import { HowItWork } from "../components/home/how-it-work";
import { Helmet } from "react-helmet-async";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import ListPropertyServices from "../../src/services/list-property-service";
import { handleErrors } from "../utils/errorHandler";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ownBuilding from "../assets/images/sell-page.png";
import buymoduleService from "../services/BuyModule-service/buy-module-service";
import sellfromdata from "../services/saleFormService";
import { validateSellForm } from "../utils/validation/validateSellPropertyData";
import { Skeleton } from "primereact/skeleton";
export default function Sell() {
  // State to hold form values
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    whatsappNumber: "",
    propertyType: "",
    apartmentType: "",
    status: "",
    bedRoomType: "",
    propertyLocation: "",
    propertyDetails: "",
    PropertyName: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false); // For loading state
  const [errors, setErrors] = useState({});
  const [submissionStatus, setSubmissionStatus] = useState("");
  const [propertyType, setPropertyType] = useState([]);
  const [bhkTypes, setBhkTypes] = useState([]);
  const [location, setLocation] = useState([]);
  const [loading, setLoding] = useState(false);
  const [error, setError] = useState("");

  //calling api to get property type and bhk type and location type data from backend
  useEffect(() => {
    const fetchDetails = async () => {
      setLoding(true);
      try {
        const [propertyResponse, bhkresponse, locationResponse] =
          await Promise.all([
            buymoduleService.allPropertyType(),
            buymoduleService.allbhk(),
            buymoduleService.allLocations(),
          ]);
        setPropertyType(propertyResponse.data?.result || []);
        setBhkTypes(bhkresponse.data?.result || []);
        setLocation(locationResponse.data?.result || []);
      } catch (error) {
        // console.log("error while accessing");
        setError(error);
      } finally {
        setLoding(false);
      }
    };
    fetchDetails();
  }, []);

  // Handle input changes
  const handleInputChange = (e, name) => {
    if (typeof e === "string" || e === null || e === undefined) {
      // Handle PhoneInput case where value may be undefined
      setFormData({
        ...formData,
        [name]: e || "", // Default to an empty string if value is undefined
      });
    } else {
      // Handle normal input case
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value,
      });
    }
    // console.log(formData);
  };

  // Handle form submission
  const handleSubmit = async () => {
    const formErrors = validateSellForm(formData);
    setErrors(formErrors);
    if (Object.keys(formErrors).length === 0) {
      try {
        setIsSubmitting(true);
        setSubmissionStatus("");
        const response = await sellfromdata(formData);
        // Show success message
        setSubmissionStatus(
          "Thank you for contacting us! We’ll be in touch soon.",
        );
      } catch (error) {
        let errorMessage = handleErrors(error);
        if (error.response && error.response.status === 500) {
          errorMessage = error.response.data.message;
        }
        toast.error(errorMessage);
      } finally {
        setIsSubmitting(false);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          contactNumber: "",
          whatsappNumber: "",
          propertyType: "",
          apartmentType: "",
          status: "",
          bedRoomType: "",
          propertyLocation: "",
          propertyDetails: "",
          PropertyName: "",
        });
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>List Your Property | WeRentt</title>
        <meta
          name="description"
          content="List your property on SoWeRent Technology LLP for tenants to discover and rent easily. Fill out the details and submit your property listing."
        />
      </Helmet>
      <section className="own-building pt-80">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-md-6">
              <div className="section-heading align-items-start mb-0">
                <h2>Own a Building, Flat, Villa, or Plot?</h2>

                <div className="sec-line">
                  <span className="sec-line1" />
                  <span className="sec-line2" />
                </div>
                <h3>Sell It Faster With Us!</h3>
                <p>
                  List your property in just a few easy steps and reach genuine
                  buyers instantly. Enjoy a smooth, transparent selling
                  experience with expert support, accurate pricing, and
                  end-to-end assistance until the deal is closed.
                </p>
                <Link to="/contact-us" className="btn btn-primary">
                  Explore our Property Management
                </Link>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="image">
                <img src={ownBuilding} alt="Building" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="grediant-section-bg">
        <Container>
          {submissionStatus ? (
            <div className="text-center">
              <h1 className="text-success">{submissionStatus}</h1>
            </div>
          ) : (
            <Row>
              <Col lg={6} md={8} className="mx-auto">
                <div className="rent-prop-title text-center">
                  <h1>Quick Start to Selling Your Property</h1>
                  <p>
                    Complete a simple form and start receiving buyer inquiries.
                  </p>
                </div>
                <Form>
                  <Row>
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>First Name</Form.Label>
                        <Form.Control
                          id="first-name"
                          type="text"
                          name="firstName"
                          className={`form-control ${
                            errors.firstName ? "is-invalid" : ""
                          }`}
                          placeholder="Enter your first name"
                          value={formData.firstName}
                          onChange={handleInputChange}
                          // isInvalid={!!errors.firstName} // Show error styling
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.firstName}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Last Name</Form.Label>
                        <Form.Control
                          id="last-name"
                          className={`form-control ${
                            errors.lastName ? "is-invalid" : ""
                          }`}
                          type="text"
                          name="lastName"
                          placeholder="Enter your last name"
                          value={formData.lastName}
                          onChange={handleInputChange}
                          // isInvalid={!!errors.lastName} // Show error styling
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.lastName}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Email Id</Form.Label>
                        <Form.Control
                          id="email"
                          className={`form-control ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          type="email"
                          name="email"
                          placeholder="Enter your email"
                          value={formData.email}
                          onChange={handleInputChange}
                          // isInvalid={!!errors.email} // Show error styling
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.email}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Contact Number</Form.Label>
                        <PhoneInput
                          international
                          defaultCountry="IN"
                          id="contact-number"
                          maxLength="15"
                          name="contactNumber"
                          className={`form-control ${
                            errors.contactNumber ? "is-invalid" : ""
                          }`}
                          placeholder="Enter your phone number"
                          value={formData.contactNumber || ""} // Ensure value is never undefined
                          onChange={(value) =>
                            handleInputChange(value, "contactNumber")
                          } // Pass value and field name
                          // isInvalid={!!errors.contactNumber} // Show error styling
                        />

                        <div className="text-danger sell-form-phone-error">
                          {" "}
                          {errors.contactNumber}
                        </div>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>WhatsApp Number</Form.Label>
                        <PhoneInput
                          international
                          defaultCountry="IN"
                          id="whatsapp-number"
                          maxLength="15"
                          name="whatsappNumber"
                          className={`form-control ${
                            errors.whatsappNumber ? "is-invalid" : ""
                          }`}
                          placeholder="Enter your WhatsApp number"
                          value={formData.whatsappNumber || ""}
                          onChange={(value) =>
                            handleInputChange(value, "whatsappNumber")
                          } // Pass value and field name
                          // isInvalid={!!errors.whatsappNumber} // Show error styling
                        />
                        <div className="text-danger sell-form-phone-error">
                          {errors.whatsappNumber}
                        </div>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Property Name</Form.Label>
                        <Form.Control
                          id="PropertyName"
                          className={`form-control ${
                            errors.PropertyName ? "is-invalid" : ""
                          }`}
                          type="text"
                          name="PropertyName"
                          placeholder="Enter Property Name"
                          value={formData.PropertyName}
                          onChange={handleInputChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.PropertyName}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      {/* //property type */}
                      <Form.Group className="form-group">
                        <Form.Label>Property Type</Form.Label>
                        <Form.Select
                          className={`form-control ${
                            errors.propertyType ? "is-invalid" : ""
                          }`}
                          name="propertyType"
                          value={formData.propertyType}
                          onChange={handleInputChange}
                          disabled={loading}
                        >
                          <option value="">
                            {loading
                              ? "Loading property types..."
                              : "Select Property Type"}
                          </option>
                          {propertyType.map((item) => (
                            <option value={item.propertyType}>
                              {item.propertyType}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.propertyType}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="form-group">
                        <Form.Label>Apartment Type</Form.Label>
                        <Form.Select
                          className={`form-control ${
                            errors.apartmentType ? "is-invalid" : ""
                          }`}
                          name="apartmentType"
                          value={formData.apartmentType}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Apartment Type</option>

                          <option value="Residential">Residential</option>
                          <option value="Commercial">Commercial</option>
                          <option value="mixed-type">Mixed-Type</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.apartmentType}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="form-group">
                        <Form.Label>Bedroom/BHK</Form.Label>
                        <Form.Select
                          className={`form-control ${
                            errors.bedRoomType ? "is-invalid" : ""
                          }`}
                          name="bedRoomType"
                          value={formData.bedRoomType}
                          onChange={handleInputChange}
                          disabled={loading}
                        >
                          <option value="">
                            {loading ? "BHK Data Is Loading" : "Select BHK"}
                          </option>
                          {error ? (
                            <p>No BHK Found</p>
                          ) : (
                            bhkTypes.map((item) => (
                              <option value={item.bhkType}>
                                {item.bhkType}
                              </option>
                            ))
                          )}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.bedRoomType}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="form-group">
                        <Form.Label>Status</Form.Label>
                        <Form.Select
                          className={`form-control ${
                            errors.status ? "is-invalid" : ""
                          }`}
                          name="status"
                          value={formData.status}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Status</option>

                          <option value="Ready">Ready</option>
                          <option value="Under Construction">
                            Under Construction
                          </option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.status}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Property Location</Form.Label>
                        <Form.Control
                          id="propertyLocation"
                          className={`form-control ${
                            errors.propertyLocation ? "is-invalid" : ""
                          }`}
                          type="text"
                          name="propertyLocation"
                          placeholder="Enter Property Location"
                          value={formData.propertyLocation}
                          onChange={handleInputChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.propertyLocation}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={12}>
                      <Form.Group className="form-group">
                        <Form.Label>Property Details</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          name="propertyDetails"
                          className={`form-control ${
                            errors.propertyDetails ? "is-invalid" : ""
                          }`}
                          placeholder="Enter your property Details (10-400 characters)"
                          value={formData.propertyDetails}
                          onChange={handleInputChange}
                          // isInvalid={!!errors.propertyAddress} // Show error styling
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.propertyDetails}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="text-center w-100">
                    <Button
                      type="button"
                      className="btn btn-theme-blue"
                      onClick={handleSubmit}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </Button>
                  </div>
                </Form>
              </Col>
            </Row>
          )}
        </Container>
      </section>
    </>
  );
}
